/**
 * Processing Page: shows live progress via Socket.IO (with a polling
 * fallback), and redirects to the Results page once the job completes.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProgressSteps from '../components/ProgressSteps';
import { getStatus } from '../api/api';
import { useJobProgress } from '../context/SocketContext';

export default function ProcessingPage() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ steps: {}, overallProgress: 0 });

  const handleProgress = useCallback(
    (payload) => {
      setStatus(payload);
      if (payload.status === 'completed') {
        navigate(`/results/${jobId}`);
      }
    },
    [jobId, navigate]
  );

  useJobProgress(jobId, handleProgress);

  // Polling fallback in case the socket connection drops.
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const { data } = await getStatus(jobId);
        handleProgress(data);
      } catch (err) {
        // ignore transient polling errors
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [jobId, handleProgress]);

  return (
    <div className="max-w-xl mx-auto">
      <ProgressSteps steps={status.steps} overallProgress={status.overallProgress} error={status.error} />
      {status.status === 'failed' && (
        <p className="text-center text-red-600 text-sm mt-4">
          Processing failed. Please try uploading again.
        </p>
      )}
    </div>
  );
}
